import { Injectable } from "@angular/core";

import { AiIntegrationsService } from "./ai-integrations.service";

/**
 * Usos de IA feitos durante a criação de um imóvel, antes de ele ter id
 * (ex.: o título grátis). Só se sabe o id depois de gravar e o modal destrói o
 * componente do anúncio logo a seguir, por isso as chaves vivem aqui até ao
 * `commit`, no mesmo padrão do AiExtractionStateService.
 */
@Injectable({ providedIn: "root" })
export class AiUsageLinkStateService {
  private keys = new Set<string>();

  constructor(private aiService: AiIntegrationsService) {}

  /** Regista a idempotencyKey de um uso feito sem imóvel. */
  track(idempotencyKey: string | null | undefined) {
    const key = String(idempotencyKey ?? "").trim();
    if (key) this.keys.add(key);
  }

  get hasPending(): boolean {
    return this.keys.size > 0;
  }

  /** Esquece as chaves (criação abandonada). */
  clear() {
    this.keys.clear();
  }

  /**
   * Chamado quando o imóvel foi criado com sucesso. Uma falha aqui não afeta a
   * gravação, que já aconteceu; no pior caso o próximo título desse imóvel
   * sai grátis outra vez.
   */
  commit(propertyId: string | null | undefined) {
    const keys = Array.from(this.keys);
    this.keys.clear();
    if (!propertyId || !keys.length) return;

    this.aiService.linkUsageToProperty(propertyId, keys).subscribe({
      next: () => {},
      error: () => {},
    });
  }
}
